module.exports = __webpack_public_path__ + "img/intranet.696772c9.png";